export const capitalizeWords = (text) =>{

    if(typeof text === 'string' && text?.length > 0){
        return text.replace(/\b[a-z]/g,c=>c.toUpperCase());
    }

    return 'agregue un string correcto'
}